import {
  DateTime,
} from 'luxon'

import DEFAULT_AMOUNT_FILTER from "../BankReconciliation.constants/DEFAULT_AMOUNT_FILTER"

const filterInvoices = ({
  allInvoices = [],
  searchTerm = '',
  invoicesDateFilter = null,
  invoicesAmountFilter = DEFAULT_AMOUNT_FILTER,
} = {}) => {
  const invoiceSearchTerm = searchTerm.trim()

  return allInvoices.filter(({
    orderNumber = '',
    paymentDueDate = '',
    invoiceAmount = 0,
  } = {}) => {
    const matchesSearch = orderNumber
      .toLowerCase()
      .includes(invoiceSearchTerm.toLowerCase())

    const withinDateRange = invoicesDateFilter
      ? DateTime.fromISO(paymentDueDate) >= invoicesDateFilter.start
        && DateTime.fromISO(paymentDueDate) <= invoicesDateFilter.end
      : true

    const invoiceCost = parseFloat(
      invoiceAmount,
    )
    const matchesAmount = invoicesAmountFilter.value
      ? invoiceCost === +invoicesAmountFilter.value
      : true

    const matchesAmountRange = (!invoicesAmountFilter.minAmount || invoiceCost >= +invoicesAmountFilter.minAmount)
      && (!invoicesAmountFilter.maxAmount || invoiceCost <= +invoicesAmountFilter.maxAmount)

    return matchesSearch && withinDateRange && matchesAmount && matchesAmountRange
  })
}

export default filterInvoices
